export const UNITS = {
  CC: 'cc',
  LBS: 'lbs',
  HP: 'HP',
  'kilo-EN': 'K',
  'kilo-PL': 'tys.',
  'kilo-FR': 'K',
  'kilo-ES': 'K',
};
